module.exports = "pegasus/assets/vr-logo-2.gif";